import { useTranslation } from 'react-i18next';

import { Card } from '@/components/atoms/Card';
import { Caption } from '@/components/atoms/Eyebrow';
import { formatNumberMaxDecimalsByLocale } from '@/utils/localeFormatters';

import { formatBoardWeight } from '../../helpers/weightText';

import styles from './MergeFishGroupModal.module.scss';

interface MergeTotalsProps {
    fishCount: number | null;
    /** Weighted by count over the licensed weights; null when any is missing. */
    grams: number | null;
    /** A ticked group's details haven't loaded yet. */
    loading: boolean;
}

/** "Total fish" and "Calculated mean weight" of the group the merge creates. */
export default function MergeTotals(props: MergeTotalsProps) {
    const { fishCount, grams, loading } = props;
    const { t, i18n } = useTranslation('fishGroups');
    const locale = i18n.language;
    const placeholder = loading ? t('siteActions.merge.loading') : '–';
    return (
        <Card variant="subtle" padding="xs" radius="sm">
            <dl className={styles.totals}>
                <div>
                    <Caption as="dt">{t('siteActions.merge.totalFish')}</Caption>
                    <dd className={styles.total}>
                        {fishCount !== null
                            ? formatNumberMaxDecimalsByLocale(fishCount, locale)
                            : placeholder}
                    </dd>
                </div>
                <div>
                    <Caption as="dt">{t('siteActions.merge.meanWeight')}</Caption>
                    <dd className={styles.total} title={t('siteActions.merge.meanWeightTitle')}>
                        {grams !== null ? formatBoardWeight(grams, locale) : placeholder}
                    </dd>
                </div>
            </dl>
        </Card>
    );
}
